/**
 * Created by Bart Decorte
 * Date: 14/05/2020
 * Time: 19:44
 */
import EpochFilter from './EpochFilter';

export default class DateTimeFilter extends EpochFilter {
  constructor($root) {
    const params = {};
    params.format = 'd/m/Y H:i';
    params.enableTime = true;
    super($root, params);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/DateTimeFilter.js